import React, { useEffect } from "react";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.fusshn.fusshncustomer";
const APP_STORE_URL =
  "https://apps.apple.com/in/app/fusshn-ticket-to-convenience/id6745167053";

const StorePage = () => {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(ua)) {
      window.location.href = PLAY_STORE_URL;
    } else if (/iPad|iPhone|iPod/.test(ua)) {
      window.location.href = APP_STORE_URL;
    } else {
      window.location.href = "/";
    }
  }, []);

  return (
    <div className="bg-[#0A0A0A] min-h-screen text-white font-['Poppins'] flex items-center justify-center px-4">
      <p className="text-center text-[16px] text-[#B3B3B3]">
        Redirecting you to the Fusshn App…
      </p>
    </div>
  );
};

export default StorePage;
